import request from "@/utils/request";

// 获取支付宝code
export const getAliUserLoginH5 = data => {
  return request({
    url: "/venue/userInfo/getAliUserLoginH5",
    method: "POST",
    data
  });
};

// 获取公众号code
export const getWxUserLoginH5 = data => {
  return request({
    url: "/venue/userInfo/getWxUserLoginH5",
    method: "POST",
    data
  });
};

// 获取云端支付订单
export const getCloudPreOrderInfo = data => {
  return request({
    url: "/venueCloud/order/getCloudPreOrderInfo",
    method: "POST",
    data
  });
};

// 获取支付订单
export const getPreOrderInfo = data => {
  return request({
    url: "/venue/order/getPreOrderInfo",
    method: "POST",
    data
  });
};

// 支付校验
export const checkPre = data => {
  return request({
    url: "/venue/api/checkPre",
    method: "POST",
    data
  });
};
// 支付校验
export const cloudCheckPre = data => {
  return request({
    url: "/venueCloud/api/checkPre",
    method: "POST",
    data
  });
};

// 云端支付
export const getCloudOrderPayInfo = data => {
  return request({
    url: "/venueCloud/payment/getCloudOrderPayInfo",
    method: "POST",
    data
  });
};

// 支付
export const getOrderPayInfo = data => {
  return request({
    url: "/venue/payment/getOrderPayInfo",
    method: "POST",
    data
  });
};

// 获取公众号appid
export const getParkLoginInfo = data => {
  return request({
    url: "/venue/userInfo/getParkLoginInfo",
    method: "POST",
    data
  });
};

// 获取云端出口缴费信息-静态码
export const getCloudStaticCodeExitOrderInfo = data => {
  return request({
    url: "/venueCloud/order/getCloudStaticCodeExitOrderInfo",
    method: "POST",
    data
  });
};

// 获取云端出口缴费信息-动态码
export const getCloudDynamicCodeExitOrderInfo = data => {
  return request({
    url: "/venueCloud/order/getCloudDynamicCodeExitOrderInfo",
    method: "POST",
    data
  });
};
// 获取出口缴费信息-静态码
export const getStaticCodeExitOrderInfo = data => {
  return request({
    url: "/venue/order/getStaticCodeExitOrderInfo",
    method: "POST",
    data
  });
};

// 获取出口缴费信息-动态码
export const getDynamicCodeExitOrderInfo = data => {
  return request({
    url: "/venue/order/getDynamicCodeExitOrderInfo",
    method: "POST",
    data
  });
};

// 无牌车入场
export const nullPlateEntry = data => {
  return request({
    url: "/venue/parklot/unCardRegister/register",
    method: "POST",
    data
  });
};

// 获取车牌号码
export const getHistoryCarNumber = query => {
  return request({
    url: "/venue/system/userInfoCar/list",
    method: "GET",
    params: query
  });
};

// 增加车牌号码
export const addHistoryCarNumber = data => {
  return request({
    url: "/venue/system/userInfoCar/addUserCar",
    method: "POST",
    data
  });
};

// 增加车牌号码
export const delHistoryCarNumber = data => {
  return request({
    url: "/venue/system/userInfoCar/deleteUserCar",
    method: "POST",
    data
  });
};

// 获取车牌号码
export const cloudGetHistoryCarNumber = query => {
  return request({
    url: "/venueCloud/system/userInfoCarCloud/list",
    method: "GET",
    params: query
  });
};

// 增加车牌号码
export const cloudAddHistoryCarNumber = data => {
  return request({
    url: "/venueCloud/system/userInfoCarCloud/addUserCar",
    method: "POST",
    data
  });
};

// 删除车牌号码
export const cloudDelHistoryCarNumber = data => {
  return request({
    url: "/venueCloud/system/userInfoCarCloud/deleteUserCar",
    method: "POST",
    data
  });
};
// 无牌车入场
export const cloudNullPlateEntry = data => {
  return request({
    url: "/venueCloud/parklot/unCardRegister/register",
    method: "POST",
    data
  });
};
